import styled, { ThemeProvider } from 'styled-components';
import { theme } from 'utils/theme';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;

    & > * {
        margin: ${({ theme }) => theme.space_4}px 0;
        padding: ${({ theme }) => theme.space_2}px;
        font-family: ${({ theme }) => theme.style_primary};
        font-size: ${({ theme }) => theme.fontSize_base};
    }

    & label {
        position: static;
        color: ${({ theme }) => theme.neutral_3};
        font-weight: ${({ theme }) => theme.fontSemiBold};
        margin-bottom: ${({ theme }) => theme.space_2}px;
    }

    & input,
    & textarea {
        outline-color: ${({ theme }) => theme.purple_1};
    }
`;

function ThemeWrapper(props) {
    return (
        <ThemeProvider theme={theme}>
            <Wrapper {...props} />
        </ThemeProvider>
    );
}

const ButtonBar = styled.div`
    display: flex;
    justify-content: space-between;
`;

const SwalContent = { Wrapper, ThemeWrapper, ButtonBar };

export default SwalContent;
